import React, { useState } from 'react';
import { TextInput, Tag } from 'carbon-components-react';
import { Add16 } from '@carbon/icons-react';

const TextFormControl = props => {
  const [value, setValue] = useState('');
  const [tags, setTags] = useState(props.formData || []);
  let inputText;

  const onChange = event => {
    setValue(event.target.value);
  };

  const addOption = event => {
    event.preventDefault();

    const value = inputText.value;
    if (!value) return;

    setTags([...tags, value]);
    props.onChange([...tags, value]);
    setValue('');
  };

  const deleteOption = event => {
    const value = event.currentTarget.innerText;
    setTags(tags.filter(tag => tag !== value));
  };

  return (
    <div className='form-control_options'>
      <TextInput
        id={props.idSchema.$id}
        ref={input => (inputText = input)}
        type='text'
        labelText={props.schema.title}
        placeholder={props.schema.placeholder}
        light
        invalid={false}
        invalidText='A valid value is required'
        onChange={onChange}
        value={value}
      />
      <button
        type='button'
        className='bx--btn--ghost form-control_add-option-icon'
        onClick={addOption}
      >
        <Add16 />
      </button>
      {tags.map((tag, i) => (
        <Tag
          key={`${props.idSchema.$id}-tag-${i}`}
          type='warm-gray'
          filter
          onClick={deleteOption}
        >
          {tag}
        </Tag>
      ))}
    </div>
  );
};

export default TextFormControl;
